import { render, staticRenderFns } from "./HistoryCharacterization.vue?vue&type=template&id=595217c2"
import script from "./HistoryCharacterization.vue?vue&type=script&lang=js"
export * from "./HistoryCharacterization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports